import { useRef, useState } from 'react';

export function uploadError(file: { name: string; size: number }): string {
  if (!file.name.toLowerCase().endsWith('.xlsx')) return '请上传 XLSX 文件';
  if (file.size > 32 * 1024 * 1024) return '文件不能超过 32 MB';
  return '';
}

export function BatchUpload({ busy, name, statistics, onUpload, onError }: {
  busy: boolean;
  name?: string;
  statistics?: Record<string, number>;
  onUpload: (file: File) => void;
  onError: (message: string) => void;
}) {
  const input = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);
  function choose(files: FileList | null) {
    if (busy || !files?.length) return;
    if (files.length !== 1) { onError('每次请上传一个文件'); return; }
    const error = uploadError(files[0]);
    if (error) { onError(error); return; }
    onUpload(files[0]);
  }
  return <>
    <h2 className="batch-section-title">上传填写完成的批量查询表</h2>
    <div className={`batch-upload ${dragging ? 'dragging' : ''}`} aria-busy={busy}
      onDragOver={e => { e.preventDefault(); if (!busy) setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={e => { e.preventDefault(); setDragging(false); choose(e.dataTransfer.files); }}>
      <span className="batch-upload-icon" aria-hidden="true">{name ? '✓' : '↑'}</span>
      <h3>{busy ? '正在上传并校验…' : name || '拖拽 Excel 文件到这里，或选择文件'}</h3>
      <p>{name ? '文件解析与去重已完成，可以继续提交。' : '仅支持 .xlsx · 单批支持 200,000 条 · 不超过 32 MB'}</p>
      <button className={name ? '' : 'primary'} disabled={busy} onClick={() => input.current?.click()}>{name ? '重新上传' : '选择文件'}</button>
      <input ref={input} hidden aria-label="上传查询文件" type="file" accept=".xlsx" disabled={busy}
        onChange={e => { choose(e.target.files); e.target.value = ''; }}/>
    </div>
    {statistics && <div className="batch-metrics">{[['原始数据','total'],['重复数据','duplicates'],['格式错误','invalid'],['有效数据','valid']].map(([label,key]) => <div key={key}><small>{label}</small><strong>{(statistics[key] ?? 0).toLocaleString()}</strong></div>)}</div>}
  </>;
}
